import Navbar from '@/pages/home/components/Navbar';
import HeroSection from '@/pages/home/components/HeroSection';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import ProductScroll from '@/pages/home/components/ProductScroll';
import CTASection from '@/pages/home/components/CTASection';
import SEOArticleSection from '@/pages/home/components/SEOArticleSection';
import SEOArticlesGrid from '@/pages/home/components/SEOArticlesGrid';
import TestimonialSection from '@/pages/home/components/TestimonialSection';
import FooterSection from '@/pages/home/components/FooterSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ProductScroll />
        <CTASection />
        <SEOArticleSection />
        <SEOArticlesGrid />
        <TestimonialSection />
      </main>
      <FooterSection />
    </>
  );
}